export function getIncVatPriceUms(data) {
    if (!data || data.length === 0) return 0;
    return data.reduce(function(min, item) {
        return item.ratio_unit < min.ratio_unit ? item : min;
    }).price_1;
}
